import PageHero from "@/components/site/PageHero";
import CapabilityGrid from "@/components/site/CapabilityGrid";
import GoldenThread from "@/components/site/GoldenThread";
import { IMAGES } from "@/data/content";
import { useSEO } from "@/hooks/useSEO";

export default function Companies() {
  useSEO(
    "Our Companies — Hapo Group",
    "Nine independent companies. One connected strategy. Explore Hapo Technology, Hapo Cloud, Hapo Media, Hapo Payment Solutions, Hapo Electronics, Hapo Energy, Hapo Intelligence, Hapo Sound and XR Africa."
  );

  return (
    <>
      <PageHero
        short
        eyebrow="Our Companies"
        lines={["Nine independent companies.", "One connected strategy."]}
        image={IMAGES.devices}
      />
      <CapabilityGrid hub />
      <GoldenThread />
    </>
  );
}
